import { useQuery } from '@tanstack/react-query';
import { getMerchantNotificationsEventNames } from 'config/requests/merchants';

export const useGetMerchantNotificationsEventNames = () => {
  const { data: eventNames, isLoading } = useQuery({
    queryKey: ['merchant_notification_event_names'],
    queryFn: getMerchantNotificationsEventNames,
    staleTime: Infinity,
  });

  return { eventNames, isLoading };
};
